export default __webpack_public_path__ + "src/assets/google-play-badge.7654289253ae3adbf37262f943aaca7d.png";